import lordsMobileRoutes from './LordsMobile/lordsMobile.routes';
import wordsRoutes from './Words/words.routes';
const routes = lordsMobileRoutes.concat(wordsRoutes);

export default routes;
